import { Checkbox, Grid, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import React from "react";
import AuthService from "../../../AuthService";
const FormDialogGerarMesas = (props) => {
  const [numInicial, setNumInicial] = React.useState("");
  const [numFinal, setNumFinal] = React.useState("");
  const [tipo, setTipo] = React.useState("");
  const [viewOnly, setViewOnly] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    props.close();
  };

  const handleGerar = () => {
    let service = new AuthService();
    service
      .post(
        `/identificador/gerar/${numInicial}/${numFinal}/${tipo}/${viewOnly}`
      )
      .then((retorno) => {
        enqueueSnackbar(`Foram gerados ${retorno.length} identificadores`, {
          variant: "success",
        });
        if (props.handleRefresh) {
          props.handleRefresh();
          handleClose();
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao gerar identificadores", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar(
              `Falha ao gerar identificadores - ${elem.errorMessage}`,
              { variant: "error" }
            );
          });
        }
      });
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={handleClose}
      maxWidth="sm"
      aria-labelledby="form-dialog-title"
      style={{ height: "70vh", minHeight: "490px" }}
    >
      <DialogTitle
        id="form-dialog-title"
        style={{ fontFamily: "Bebas Neue", textTransform: "uppercase" }}
      >
        Gerar mesas ou comandas
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Informe o número inicial, final e tipo (MESA ou COMANDA)
        </DialogContentText>

        <Grid container spacing={2}>
          <Grid size={6}>
            <TextField
              autoFocus
              margin="dense"
              id="numInicial"
              label="Número inicial da mesa. Ex: 1"
              type="number"
              required
              value={numInicial || ""}
              onChange={(e) => setNumInicial(e.target.value)}
              fullWidth
              variant="outlined"
            />
          </Grid>

          <Grid size={6}>
            <TextField
              margin="dense"
              id="numFinal"
              required
              label="Número final da mesa. Ex: 20"
              type="number"
              onChange={(e) => setNumFinal(e.target.value)}
              value={numFinal || ""}
              fullWidth
              variant="outlined"
            />
          </Grid>

          <Grid size={12}>
            <TextField
              id="tipo"
              fullWidth
              select
              value={tipo || ""}
              name="tipo"
              label="Tipo"
              margin="normal"
              variant="outlined"
              onChange={(e) => setTipo(e.target.value)}
            >
              <MenuItem value="MESA">Tipo MESA</MenuItem>
              <MenuItem value="COMANDA">Tipo COMANDA</MenuItem>
            </TextField>
          </Grid>

          <Grid size={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={viewOnly}
                  onChange={() => setViewOnly(!viewOnly)}
                  name="Somente visualização"
                  color="secondary"
                />
              }
              label="Somente visualização"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleGerar} variant="contained" color="primary">
          Gerar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormDialogGerarMesas;
